import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TabsModule, TooltipModule } from 'ngx-bootstrap';
import { CandidateJobMatchProfileComponent } from './candidate-job-match-profile.component';
import { CandidateProfileModule } from 'src/app/pages/mission-control-page/candidateprofile-page/candidate-profile/candidate-profile.module';
import { JobProfileModule } from 'src/app/pages/mission-control-page/job-profile-page/job-profile/job-profile.module';
import { CandidateJobComparisonPageModule } from 'src/app/pages/mission-control-page/candidate-job-comparison-page/candidate-job-comparison-page.module';
import { CandidateDocumentsModule } from 'src/app/pages/mission-control-page/candidateprofile-page/candidate-documents/candidate-documents.module';

@NgModule({
  declarations: [CandidateJobMatchProfileComponent],
  imports: [
    CommonModule,
    TabsModule.forRoot(),
    TooltipModule,
    CandidateProfileModule,
    JobProfileModule,
    CandidateJobComparisonPageModule,
    CandidateDocumentsModule
  ],
  exports: [CandidateJobMatchProfileComponent],
  entryComponents: [CandidateJobMatchProfileComponent]
})
export class CandidateJobMatchProfileModule { }
